module.exports = __webpack_public_path__ + "static/media/Screenshot--marketplace.2f4369d6.png";